import { createCharacter } from './builder';
import { createAttackAnimation, createIdleAnimation, createJumpAnimation, createRunAnimation } from './animations';
import { RUN_SPEED } from './constants';
import { createBasicLifecycleScript } from '../lifecycle';

export const HOTDOG_CONFIG = createCharacter({
  id: 'hotdog',
  name: 'Hotdog',
  assetPath: '/assets/characters/hotdog/Drunk Idle.glb',
  scale: 1.0,
  modelAxes: {
    forward: { x: 0, y: 0, z: -1 },
    up: { x: 0, y: 1, z: 0 }
  },
  moveSpeed: RUN_SPEED,
  physics: {
    jumpHeight: 1.8
  },
  collidesWithCharacters: false,
  turnMode: 'interpolate',
  animations: {
    idle: createIdleAnimation('/assets/characters/hotdog/Drunk Idle.glb', {
      applyRootMotion: true
    }),
    run: createRunAnimation('/assets/characters/hotdog/Drunk Running Left Turn.glb'),
    turn: createRunAnimation('/assets/characters/hotdog/Drunk Turn.glb', {
      lockFacing: true,
      speed: 2,
      applyRootMotion: true
    }),
    jump: createJumpAnimation('/assets/characters/hotdog/Jump.glb'),
    attack_magic: createAttackAnimation('/assets/characters/hotdog/Standing 2H Magic Attack 04.glb', {
      applyRootMotion: true
    }),
    hit_react: createIdleAnimation('/assets/characters/hotdog/Hit On Side Of Head.glb', {
        speed: 2,
        phases: {
            windup: { start: 0.0, end: 0.2 },
            active: { start: 0.2, end: 0.55 },
            recovery: { start: 0.55, end: 1.0 }
        }
    }),
    death: createIdleAnimation('/assets/characters/hotdog/Zombie Dying.glb',{
        speed: 4,
        applyRootMotion: true
    })
  },
  transitions: [
    { from: 'idle', to: 'turn', duration: 0.1 },
    { from: 'run', to: 'turn', duration: 0.15 },
    { from: 'turn', to: 'run', duration: 0.2 },
    { from: 'turn', to: 'idle', duration: 0.15 },
    { from: 'land', to: 'run', duration: 0.15, blendRatio: 0.3 },
    { from: 'land', to: 'idle', duration: 0.2 },
    { from: 'run', to: 'idle', duration: 0.2 },
    { from: 'idle', to: 'run', duration: 0.3 }
  ],
  lifecycle: createBasicLifecycleScript({
    id: 'hotdog-default-lifecycle',
    hitAnimation: 'hit_react',
    deathAnimation: 'death',
    despawnMode: 'after-animation'
  })
});
